import { Check, FlaskConical, TrendingUp, HandCoins, ArrowRight } from "lucide-react";

const tracks = [
    {
        icon: HandCoins,
        tag: "Grant Funding",
        title: "Foundation & public-health grants",
        bullets: [
            "Actively seeking SAMHSA, HRSA, and state opioid-response funding to scale early deployments",
            "Open to foundations focused on harm reduction, public health, and the opioid crisis",
            "Built to measure outcomes — every unit becomes evidence for the next funding cycle",
        ],
        ctaInquiry: "partner",
    },
    {
        icon: FlaskConical,
        tag: "Pilot Sites",
        title: "First-wave pilot partners",
        bullets: [
            "Looking for our first deployment sites — correctional, municipal, healthcare, or nonprofit",
            "Co-designed pilots with outcome dashboards and audit-ready reporting",
            "Onboarding, training, and field support included end-to-end",
        ],
        ctaInquiry: "partner",
    },
    {
        icon: TrendingUp,
        tag: "Investors",
        title: "Mission-aligned capital",
        bullets: [
            "Recurring-revenue model on a public-health distribution gap",
            "Multi-billion-dollar TAM across U.S. crisis-response spend",
            "Founders open to strategic, values-aligned partners",
        ],
        ctaInquiry: "invest",
    },
];

export const Partnership = () => {
    return (
        <section
            id="partnership"
            data-testid="partnership-section"
            className="relative bg-slate-50 py-28 md:py-36 border-y border-slate-200"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal max-w-3xl">
                    <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                        How To Get Involved
                    </span>
                    <h2 className="mt-6 font-display font-extrabold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-[#0A1428] text-balance">
                        We&apos;re early.
                        <br />
                        That&apos;s the opportunity.
                    </h2>
                    <p className="mt-8 max-w-2xl text-base md:text-lg text-slate-600 font-medium leading-relaxed">
                        Kairos ORD is a pre-deployment startup seeking the
                        partners, funders, and investors who want to help build
                        the response infrastructure the opioid crisis demands.
                    </p>
                </div>

                <div className="mt-16 grid grid-cols-1 lg:grid-cols-3 gap-6">
                    {tracks.map((t, i) => (
                        <div
                            key={t.title}
                            data-testid={`partner-track-${i}`}
                            className="reveal bg-white border border-slate-200 p-8 md:p-10 flex flex-col hover:border-[#0A1428] transition-colors"
                        >
                            <div className="h-12 w-12 grid place-items-center border border-[#0A1428]">
                                <t.icon
                                    size={22}
                                    strokeWidth={1.5}
                                    className="text-[#F0493E]"
                                />
                            </div>
                            <div className="mt-8 text-xs font-bold uppercase tracking-[0.22em] text-slate-500">
                                {t.tag}
                            </div>
                            <h3 className="mt-3 font-display font-bold text-2xl md:text-3xl text-[#0A1428] tracking-tight">
                                {t.title}
                            </h3>
                            <ul className="mt-6 space-y-3 flex-1">
                                {t.bullets.map((b) => (
                                    <li
                                        key={b}
                                        className="flex items-start gap-3 text-sm text-slate-600 leading-relaxed font-medium"
                                    >
                                        <Check
                                            size={16}
                                            strokeWidth={2}
                                            className="mt-0.5 text-[#F0493E] shrink-0"
                                        />
                                        <span>{b}</span>
                                    </li>
                                ))}
                            </ul>
                            <button
                                data-testid={`partner-track-cta-${i}`}
                                onClick={() => {
                                    window.dispatchEvent(
                                        new CustomEvent("kairos:set-inquiry", {
                                            detail: t.ctaInquiry,
                                        })
                                    );
                                    document
                                        .getElementById("contact")
                                        ?.scrollIntoView({
                                            behavior: "smooth",
                                        });
                                }}
                                className="link-underline mt-8 inline-flex items-center gap-2 font-display font-bold text-[#0A1428] text-base"
                            >
                                Start the conversation
                                <ArrowRight size={16} strokeWidth={2} />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
